import { render, staticRenderFns } from "./BrokerFieldComment.vue?vue&type=template&id=e5710ea6&"
import script from "./BrokerFieldComment.vue?vue&type=script&lang=ts&"
export * from "./BrokerFieldComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports